<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="c01"><a id="page2"></a><em>Kelsey’s Cranberry Salsa</em></h1>
<p class="nonindent"><em>Kelsey Adams is one of those remarkable young ladies who is power-packed with giftedness. She coaches, she teaches, she creates, and she even cooks! Here is her fun and fruity salsa recipe — you’re going to love this.</em></p>
<div class="block">
<p class="center1"><em>12 ounces fresh or frozen cranberries, chopped</em><br/><em>1 Granny Smith apple, cored and chopped</em><br/><em>½ red bell pepper, seeded and chopped</em><br/><em>½ medium red onion, chopped</em><br/><em>3 tablespoons chopped fresh cilantro</em><br/><em>2 tablespoons pickled jalapeño peppers</em><br/><em>¾ cup sugar</em><br/>⅓ <em>cup apple juice</em><br/><em>Tortilla chips, for serving</em></p>
</div>
<p class="nonindent"><em>Mix all the ingredients, except for the tortilla chips, in a medium bowl. Cover and refrigerate overnight. Serve with tortilla chips of your choice. This will keep in the refrigerator for 2 weeks.</em></p>
<p class="center"><em>Makes about 4 cups</em></p>
<p class="center"><img alt="" src="OEBPS/images/9781449400217_2.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781449400217_epub_c01_r1.vue?e628203a